import Button from "./button"

export type { ButtonProps } from "./button"
export default Button
